<script>
	import FooterBrandingSection from './FooterBrandingSection.svelte';
    
    import { t } from "$lib/i18n.js";
    import FooterStoreIcons from "./FooterStoreIcons.svelte";
    import FooterLinks from "./FooterLinks.svelte";
    import FooterLogoAndSocials from './FooterLogoAndSocials.svelte';

    
</script>

<FooterBrandingSection />
<footer class="full-width">
    <div class="relative-full-width">
        <div class="logos">
            <FooterLogoAndSocials />
            <FooterStoreIcons />
        </div>
        <FooterLinks />
        <div class="boring">
            <a href="mailto:support@auting.it">support@auting.it</a>
            <p>{$t('components.footer.links_section.copyright')}</p>
        </div>
    </div>
</footer>

<style>
    .relative-full-width {
        width: 100%;
        margin: 0;
    }

    footer {
        background: #5bb6bc;
        background: -webkit-linear-gradient(
            0deg,
            rgba(89, 153, 212, 1) 0%,
            rgba(91, 182, 188, 1) 100%
        );
        background: -moz-linear-gradient(
            0deg,
            rgba(89, 153, 212, 1) 0%,
            rgba(91, 182, 188, 1) 100%
        );
        background: linear-gradient(
            0deg,
            rgba(89, 153, 212, 1) 0%,
            rgba(91, 182, 188, 1) 100%
        );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5999D4", endColorstr="#5BB6BC", GradientType=0);
        padding: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    footer .relative-full-width {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        background-color: var(--on-surface);
        max-width: var(--max-width);
        border-radius: 32px;
        padding-left: 60px;
        padding-right: 60px;
        padding-top: 72px;
        padding-bottom: 72px;
        gap: 80px;
    }

    .logos {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        width: 100%;
    }

    .boring {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .boring p {
        color: var(--surface-50);
        font-size: 14px;
        line-height: 140%;
        text-align: center;
        margin: 0;
    }

    .boring a {
        color: var(--surface);
        font-size: 18px;
        line-height: 140%;
        text-decoration: none;
        margin-bottom: 8px;
        text-align: center;
    }

    @media (max-width: 768px) {
        .logos {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 40px;
        }

        footer {
            padding: 16px;
        }

        footer .relative-full-width {
            padding-left: 16px;
            padding-right: 16px;
            padding-top: 40px;
            padding-bottom: 40px;
        }
    }
</style>
